<template>
  <modal ref='modal'>
    <template #header>
      <h5 v-if='Object.keys(contact).length === 0' class="modal-title mt-0">{{$t('contacts.add_new')}}</h5>
      <h5 v-else class="modal-title mt-0">{{$t('contacts.edit_modal.edit')}}</h5>
    </template>

    <template #body>
      <form ref='form' @submit.prevent="createOrUpdateContact($event)">
        <div class="modal-body">
          <div class="form-group">
            <label class="col-form-label">
              {{$t('contacts.edit_modal.name')}}
            </label>

            <input type="text" name="contact[name]" class="form-control" :value='contact.name'/>
          </div>

          <div class="form-group">
            <label class="col-form-label">
              {{$t('contacts.edit_modal.email')}}
            </label>

            <input type="text" name="contact[email]" class="form-control" :value='contact.email'/>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.language')}}</label>
            <select name="contact[locale]" class="form-control">
              <option :selected="contact.locale === 'en'" value='en'>{{$t('contacts.edit_modal.english')}}</option>
              <option :selected="contact.locale === 'de'" value='de'>{{$t('contacts.edit_modal.german')}}</option>
            </select>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.company')}}</label>
            <input type="text" name="contact[company]" class="form-control" :value='contact.company'/>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.position')}}</label>
            <input type="text" name="contact[position]" class="form-control" :value='contact.position'/>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.company_address')}}</label>
            <input type="text" name="contact[address]" class="form-control" :value='contact.address'/>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.notes')}}</label>
            <textarea class="form-control" name="contact[notes]" :value='contact.notes'></textarea>
          </div>
        </div>

        <div class="modal-footer">
          <input type="submit" name="commit" :value="$t('contacts.edit_modal.save_add_more')" class="btn btn-outline-primary float-right" @click.prevent='addMore' v-if='!contact.id'>
          <input type="submit" name="commit" :value="$t('contacts.edit_modal.save')" class="btn btn-primary float-right">
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'
  import _single_select from '../_single_select'

  export default {
    components: {
      modal: _modal,
      'single-select': _single_select
    },
    data() {
      return {
        contact: {},
      }
    },
    methods: {
      open(contact) {
        this.contact = contact || {}
        this.$refs.modal.open()
      },
      addMore() {
        this.store.createContact(new FormData(this.$refs.form)).then(() => {
          this.store.sendMetrics({name: 'add_contact', params: this.$route.params, path: this.$route.fullPath})
          this.contact = {}
          this.$emit('success')
          this.$toastr.success(this.$t('flash_messages.contact_created'))
        })
      },
      createOrUpdateContact(event) {
        const params = new FormData(event.target)
        let promise;
        if (this.contact.id) {
          promise = this.store.updateContact(this.contact.id, params)
          this.store.sendMetrics({name: 'update_contact', params: this.$route.params, path: this.$route.fullPath})
        } else {
          promise = this.store.createContact(params)
          this.store.sendMetrics({name: 'add_contact', params: this.$route.params, path: this.$route.fullPath})
        }

        promise.then(() => {
          this.$refs.modal.close()
          this.$emit('success')
          this.$toastr.success(this.$t('flash_messages.contact_created'))
        })
      }
    }
  }
</script>

<style lang='sass' scoped>
  p
    font-size: 12px
</style>

